import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as LinkedInFillIcon } from './linkedInFill.svg';

export const LinkedInFill = IconHOC(LinkedInFillIcon);
